// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";
import blogImg4 from "../images/blog/img-1.jpg";
import blogImg5 from "../images/blog/img-2.jpg";
import blogImg6 from "../images/blog/img-3.jpg";
import blogImg7 from "../images/blog/img-2.jpg";
import blogImg8 from "../images/blog/img-4.jpg";
import blogImg9 from "../images/blog/img-5.jpg";
import blogImg10 from "../images/blog/img-6.jpg";
import blogImg11 from "../images/blog/img-7.jpg";

import blogSingleImg1 from "../images/blog-details/1.jpg";
import blogSingleImg2 from "../images/blog-details/2.jpg";
import blogSingleImg3 from "../images/blog-details/3.jpg";
import blogSingleImg4 from "../images/blog-details/4.jpg";
import blogSingleImg5 from "../images/blog-details/5.jpg";
import blogSingleImg6 from "../images/blog-details/6.jpg";
import blogSingleImg7 from "../images/blog-details/7.jpg";


import recent1 from "../images/recent-posts/img-1.jpg";
import recent2 from "../images/recent-posts/img-2.jpg";
import recent3 from "../images/recent-posts/img-3.jpg";




const blogs = [
    {
        id: '1',
        title: 'Caring for the Elderly and Vulnerable Strategy.',
        title2: 'Budget Issues Force The Our To Become',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack',
        screens: blogImg1,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg1,
        recent: recent1,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '2',
        title: 'Varying complexity, provide long-term guarantees',
        title2: 'The Best Products That Shape Fashion.',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack2',
        screens: blogImg2,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Linda Johns',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg2,
        recent: recent2,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '3',
        title: 'Our Goal Is Help The Poor Child Around The World',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack3',
        screens: blogImg3,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg3,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '4',
        title: 'Varying complexity, provide long-term guarantees',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack4',
        screens: blogImg4,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg4,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 
    {
        id: '5',
        title: 'Caring for the Elderly and Vulnerable Strategy',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack5',
        screens: blogImg5,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg5,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '6',
        title: 'Caring for the Elderly and Vulnerable Strategy',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack6',
        screens: blogImg6,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg6,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '7',
        title: 'Our Goal Is Help The Poor Child Around The World',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack7',
        screens: blogImg7,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '8',
        title: 'If you currently get disability supports the NDIS is available in your area',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack7',
        screens: blogImg8,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '9',
        title: 'Your plan reassessment is the opportunity to check',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack7',
        screens: blogImg9,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
    {
        id: '10',
        title: 'Once you have your plan there are people who',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack7',
        screens: blogImg10,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 
    {
        id: '11',
        title: 'Your plan is an agreement worked out with your',
        title2: 'The Best Products That Shape Fashion',
        subtitle: 'Manik Doe',
        slug: 'Why-Industry-Are-A-Juicy-Target-For-Cyberattack7',
        screens: blogImg11,
        link: 'READ MORE',
        description: 'Business is the activity of making one s liv cing or buying and selling products',
        author: 'Manik Doe',
        create_at: '01-05-2024',
        blogSingleImg: blogSingleImg7,
        recent: recent3,
        comment: '35',
        day: '28',
        month: 'MAR',
        blClass: 'format-standard-image',
        animation: '1200',
    },
 


];
export default blogs;



